import React from 'react';
import MagazineLayout from './MagazineLayout';

const CatalogMagazineView = ({ products }) => {
  // Magazine view is full-width and immersive, no filters or controls
  return (
    <div className="magazine-fullscreen">
      <MagazineLayout products={products} searchTerm="" fullscreen={true} />
    </div>
  );
};

export default CatalogMagazineView;